import { AxiosError } from "axios";

export interface ApiValidationError {
    type: string;
    loc: string[];
    msg: string;
    input: unknown;
    ctx?: Record<string, unknown>;
}

interface ApiError {
    detail: string;
}

export interface IApiAxiosError extends AxiosError {
    response?: AxiosError<ApiError>["response"];
}

/**
 * Extract error message from API error response.
 * Handles both string detail and Pydantic validation error arrays.
 */
export function getApiErrorMessage(
    error: IApiAxiosError,
    fallback: string = "An error occurred"
): string {
    // Cast to unknown to handle both string and array formats
    const detail = error.response?.data?.detail as unknown;
    if (typeof detail === "string") {
        return detail;
    }
    // Handle Pydantic validation errors (array format)
    if (Array.isArray(detail) && detail.length > 0) {
        return (detail as ApiValidationError[])[0].msg;
    }
    return fallback;
}

export interface Page<T> {
    items: T[];
    total: number;
    page: number;
    size: number;
    pages: number;
}

export interface IPaginationModel {
    page: number;
    pageSize: number;
}

export interface IFilter {
    q?: string | null;
    sort_by?: string;
    order?: "asc" | "desc";
}

export interface IBaseResource {
    id: number;
    created_at: string;
    updated_at: string;
}
